import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AutomationCleanupManagementLayoutComponent } from "@app/administration/cleanup-management/automation-cleanup-management/automation-cleanup-management-layout/automation-cleanup-management-layout.component";
import { ManualCleanupManagementLayoutComponent } from "@app/administration/cleanup-management/manual-cleanup-management/manual-cleanup-management-layout/manual-cleanup-management-layout.component";
import { DataCleanupLogLayoutComponent } from "@app/administration/cleanup-management/data-cleanup-log-layout/data-cleanup-log-layout.component";

import { routesConstants } from '@app/shared/models/LinksView';

import { AdminGuard } from '@app/core/guards/admin.guard';

const routes: Routes = [
  { path: routesConstants.administrationCleanup.cleanUp, canActivate: [ AdminGuard ], component: AutomationCleanupManagementLayoutComponent },
  { path: routesConstants.administrationCleanup.manualCleanUp, canActivate: [ AdminGuard ], component: ManualCleanupManagementLayoutComponent },
  { path: routesConstants.administrationCleanup.dataCleanupLog, canActivate: [ AdminGuard ], component: DataCleanupLogLayoutComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdmininstrationCleanupManagementRoutingModule { }
